import * as React from 'react';
import styled from 'styled-components';
import * as ethers from 'ethers';
import { useTranslation } from 'react-i18next';
import { GotomypageButton } from '../../components/05nftdisplay/gotomypageButton';
import { NFTImageDisplay } from '../../components/05nftdisplay/nftImageDisplayComponent';
import { NFTInfoTextPlusURL } from '../../components/05nftdisplay/nftInfoURLComponent';
import { SushiFooter } from '../../components/suishiFooterComponent';
import { GotoMyAppButton } from '../../components/06mypage/gotoMyAppButtonComponent';
import { useRecoilValue } from 'recoil';
import { configJsonState } from '../../states/configJsonState';
import { Center, Box, Text } from '@chakra-ui/react';

type Props = {
  // languageExchange:any,
}

export const NFTdisplayPage: React.FC<Props> = (props) => {
  const [t, i18n] = useTranslation();
  const configStatus = useRecoilValue(configJsonState);
  const [imageURLFromToknURI,setImageURLFromToknURI] = React.useState(`${localStorage.getItem('NFTImageURL')}`);
  const DivComponent = styled.div`
    margin-top: 70px;
    display: inline-block;
  `;

  const NFTdisplayPageComponent = styled.main`
    text-align: center;
    color: white;
    background-repeat: no-repeat;
    background-size: 100% auto;
    font-family: 'Noto Sans JP',sans-serif;
    justify-content: center;
    height: 100vh;
    width: 100%;
    display: inline-table;

    background-image: url(${configStatus.backgroundImage});
  `;

    React.useEffect(()=>{
      (async() => {

      })();
    },[]);
  return (
    <NFTdisplayPageComponent>
        <NFTImageDisplay imageUrl={imageURLFromToknURI}/>
        {(configStatus.walletTypeArray.includes(`auWallet`) && configStatus.walletTypeArray.length == 1) ?
          <Center>
            <Box  
              backgroundColor={`white`}
              w={`270px`}
              pt={`10px`}
              pb={`10px`}
              pr={`20px`}
              pl={`20px`}
              borderRadius={`10px`}
              boxShadow=' 0 1rem 2rem hsl(0 0% 0% / 14%)'
            >
              <Text
                color={`black`}
                fontWeight={`bold`}
              >
                {t(`受け取ったNFTは`)}<br/><Box as='span' color={`#784296`} fontWeight={`bold`} >{t(`αU wallet`)}</Box>{t(`で確認できます`)}
              </Text>
            </Box>
          </Center>
          :
          <Box marginY={`12px`}>
            <GotomypageButton />
          </Box>
        }
        <NFTInfoTextPlusURL />
    </NFTdisplayPageComponent>
  );
};